/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { JobsControllerUpdateMutationRequest, JobsControllerUpdateMutationResponse, JobsControllerUpdatePathParams, JobsControllerUpdate400, JobsControllerUpdate401, JobsControllerUpdate403, JobsControllerUpdate404 } from "../../models/jobsController/JobsControllerUpdate";

function getJobsControllerUpdateUrl(id: JobsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/jobs/${id}` as const }  
  return res
}

/**
 * @summary Update a job
 * {@link /api/v1/jobs/:id}
 */
export async function jobsControllerUpdate(id: JobsControllerUpdatePathParams["id"], data?: JobsControllerUpdateMutationRequest, config: Partial<RequestConfig<JobsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<JobsControllerUpdateMutationResponse, ResponseErrorConfig<JobsControllerUpdate400 | JobsControllerUpdate401 | JobsControllerUpdate403 | JobsControllerUpdate404>, JobsControllerUpdateMutationRequest>({ method : "PATCH", url : getJobsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}